import { render, staticRenderFns } from "./NewNgbTeamMembersModify.vue?vue&type=template&id=3fd989c1"
import script from "./NewNgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./NewNgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./NewNgbTeamMembersModify.vue?vue&type=style&index=0&id=3fd989c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports